import { render, staticRenderFns } from "./warnSetting.vue?vue&type=template&id=559951e8&scoped=true&"
import script from "./warnSetting.vue?vue&type=script&lang=js&"
export * from "./warnSetting.vue?vue&type=script&lang=js&"
import style0 from "./warnSetting.vue?vue&type=style&index=0&id=559951e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559951e8",
  null
  
)

export default component.exports